import calcularComponentesExamen
from "../funciones/calcularComponentesExamen";
import {
	obtenerDiagnosticoUsuario
}
from "../funciones/motorDiagnostico";
import React, {
	useEffect,
	useState
} from "react";

import styled from "styled-components";

import {
	collection,
	getDocs
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

import { useAuth } from "../contextos/AuthContext";
import generarRecomendaciones from "../funciones/recomendaciones";
const Contenedor = styled.div`
	min-height: 100vh;

	padding: 2rem;

	background:
		radial-gradient(circle at top,
			#1f2937 0%,
			#0b1120 45%,
			#050816 100%);

	color: white;
`;

const Titulo = styled.h1`
	font-size: 2.5rem;
	margin-bottom: 2rem;
`;

const Grid = styled.div`
	display: grid;

	grid-template-columns:
		repeat(auto-fit, minmax(280px, 1fr));

	gap: 1.5rem;
`;

const Card = styled.div`
	background:
		rgba(255,255,255,0.05);

	border:
		1px solid rgba(255,255,255,0.08);

	border-radius: 24px;

	padding: 1.5rem;

	backdrop-filter: blur(10px);
`;

const Label = styled.div`
	font-size: 0.9rem;

	color:
		rgba(255,255,255,0.55);

	margin-bottom: 0.6rem;
`;

const Value = styled.div`
	font-size: 2rem;
	font-weight: 900;
`;

const MateriaRow = styled.div`
	margin-bottom: 1rem;
`;

const Barra = styled.div`
	width: 100%;
	height: 12px;

	background:
		rgba(255,255,255,0.08);

	border-radius: 999px;

	overflow: hidden;

	margin-top: 0.5rem;
`;

const Fill = styled.div`
	height: 100%;

	width: ${({ width }) => width}%;

	background:
		linear-gradient(
			90deg,
			#5b69e2,
			#7c3aed
		);
`;

const RecomGrid = styled.div`
	display: grid;

	grid-template-columns:
		repeat(auto-fit, minmax(280px, 1fr));

	gap: 1rem;

	margin-top: 2rem;
`;

const RecomCard = styled.div`
	padding: 1.2rem;

	border-radius: 22px;

	background:
		${({ tipo }) => {

			if (tipo === "danger") {
				return "rgba(239,68,68,0.12)";
			}

			if (tipo === "warning") {
				return "rgba(245,158,11,0.12)";
			}

			if (tipo === "success") {
				return "rgba(34,197,94,0.12)";
			}

			return "rgba(91,105,226,0.12)";
		}};

	border:
		1px solid
		${({ tipo }) => {

			if (tipo === "danger") {
				return "rgba(239,68,68,0.3)";
			}

			if (tipo === "warning") {
				return "rgba(245,158,11,0.3)";
			}

			if (tipo === "success") {
				return "rgba(34,197,94,0.3)";
			}

			return "rgba(91,105,226,0.3)";
		}};
`;

const RecomTitle = styled.div`
	font-size: 1rem;
	font-weight: 800;

	margin-bottom: 0.5rem;
`;

const RecomText = styled.div`
	color: rgba(255,255,255,0.7);

	line-height: 1.5;
`;

const PerfilStats = () => {

	const { usuario } = useAuth();

	const [stats, setStats] =
		useState(null);

	useEffect(() => {

		const cargar = async () => {

			const componentes =
				await calcularComponentesExamen(
					usuario.uid
				);

			console.log(
				"COMPONENTES EXAMEN:"
			);

			console.log(
				componentes
			);

			if (!usuario) return;
		
			const snap = await getDocs(
				collection(db, "progreso_metas")
			);
		
			const docs = snap.docs
				.map((d) => d.data())
				.filter(
					(d) =>
						d.userId === usuario.uid
				);
		
			if (docs.length === 0) {
				return;
			}
		
			const total = {
		
				nivel: 1,
		
				rango: "Hierro",
		
				corrupcion: 0,
		
				mejor_streak: 0,
		
				preguntas_correctas: 0,
		
				preguntas_respondidas: 0,
		
				materiasStats: {}
			};
		
			docs.forEach((d) => {
		
				total.nivel =
					Math.max(
						total.nivel,
						d.nivel || 1
					);
		
				total.corrupcion =
					Math.max(
						total.corrupcion,
						d.corrupcion || 0
					);
		
				total.mejor_streak =
					Math.max(
						total.mejor_streak,
						d.mejor_streak || 0
					);
		
				total.rango =
					d.rango || "Hierro";
		
				total.preguntas_correctas +=
					d.preguntas_correctas || 0;
		
				total.preguntas_respondidas +=
					d.preguntas_respondidas || 0;
		
				const materias =
					d.materiasStats || {};
		
				Object.entries(materias)
					.forEach(([k, v]) => {
		
						if (
							!total.materiasStats[k]
						) {
		
							total.materiasStats[k] = {
		
								correctas: 0,
		
								incorrectas: 0,
		
								noEntendidas: 0
							};
						}
		
						total.materiasStats[k]
							.correctas +=
							v.correctas || 0;
		
						total.materiasStats[k]
							.incorrectas +=
							v.incorrectas || 0;
		
						total.materiasStats[k]
							.noEntendidas +=
							v.noEntendidas || 0;
					});
			});
		
			const resultado =
				await obtenerDiagnosticoUsuario(
					usuario.uid
				);

			console.log(
				"DIAGNOSTICO:"
			);

			console.log(
				resultado
			);

			setStats(total);
		};

		cargar();

	}, [usuario]);
	

	if (!stats) {

		return (
			<Contenedor>
				Cargando estadísticas...
			</Contenedor>
		);
	}

	const totalCorrectas =
		stats.preguntas_correctas || 0;

	const totalRespondidas =
		stats.preguntas_respondidas || 0;

	const precision =
		totalRespondidas > 0
			? Math.round(
				(totalCorrectas /
				totalRespondidas) * 100
			)
			: 0;

	const materias =
		stats.materiasStats || {};

	const materiasArray =
		Object.entries(materias)
			.map(([nombre, data]) => {

				const total =
					data.correctas +
					data.incorrectas +
					data.noEntendidas;

				const porcentaje =
					total > 0
						? Math.round(
							(data.correctas / total) * 100
						)
						: 0;

				return {
					nombre,
					porcentaje,
					total
				};
			})
			.sort(
				(a, b) =>
					b.porcentaje -
					a.porcentaje
			);

	const mejorMateria =
		materiasArray[0];

	const peorMateria =
		materiasArray[
			materiasArray.length - 1
		];

    const recomendaciones =
        generarRecomendaciones(stats);        

        return (

		<Contenedor>

			<Titulo>
				📊 Perfil competitivo
			</Titulo>

			<Grid>

				<Card>

					<Label>
						Precisión Global
					</Label>

					<Value>
						{precision}%
					</Value>

				</Card>

				<Card>

					<Label>
						Nivel
					</Label>

					<Value>
						{stats.nivel}
					</Value>

				</Card>

				<Card>

					<Label>
						Rango
					</Label>

					<Value>
						{stats.rango}
					</Value>

				</Card>

				<Card>

					<Label>
						Mejor Streak
					</Label>

					<Value>
						x{stats.mejor_streak}
					</Value>

				</Card>

				<Card>

					<Label>
						Corrupción
					</Label>

					<Value>
						{stats.corrupcion}%
					</Value>

				</Card>

				<Card>

					<Label>
						Preguntas respondidas
					</Label>

					<Value>
						{stats.preguntas_respondidas}
					</Value>

				</Card>

			</Grid>

			<Card
				style={{
					marginTop: "2rem"
				}}
			>

				<Label>
					🏆 Mejor materia
				</Label>

				<Value>
					{mejorMateria?.nombre || "-"}
				</Value>

				<div>
					{mejorMateria?.porcentaje || 0}% precisión
				</div>

			</Card>

			<Card
				style={{
					marginTop: "1.5rem"
				}}
			>

				<Label>
					📉 Materia más débil
				</Label>

				<Value>
					{peorMateria?.nombre || "-"}
				</Value>

				<div>
					{peorMateria?.porcentaje || 0}% precisión
				</div>

			</Card>

			<Card
				style={{
					marginTop: "1.5rem"
				}}
			>

				<Label>
					📚 Rendimiento por materia
				</Label>



				<div
					style={{
						marginTop: "1.5rem"
					}}
				>

					{materiasArray.map((m) => (

						<MateriaRow
							key={m.nombre}
						>

							<div>
								<strong>
									{m.nombre}
								</strong>
								{" · "}
								{m.porcentaje}%
							</div>

							<Barra>

								<Fill
									width={
										m.porcentaje
									}
								/>

							</Barra>

						</MateriaRow>

					))}

				</div>

			</Card>

            <RecomGrid>

                {recomendaciones.map((r, i) => (

                    <RecomCard
                        key={i}
                        tipo={r.tipo}
                    >

                        <RecomTitle>
                            {r.titulo}
                        </RecomTitle>

                        <RecomText>
                            {r.texto}
                        </RecomText>

                    </RecomCard>

                ))}

            </RecomGrid>

		</Contenedor>
	);
};

export default PerfilStats;